import React, { useEffect } from "react";
import { StandardPageWrapper } from "../../../components/layout/StandardPageWrapper";
import { PageHeader } from "../../../components/layout/header/Header";
import { FullPageButton } from "../../../components/buttons/FullPageButton";
import "../../../../../sass/components/my-documents-page.scss";
import { useSelfOrganizationUser } from "../../../hooks/useOrganization";
import { useHistory } from "react-router";
import { PageLoading } from "../../../components";

export const MyDocumentsPage = () => {
  const history = useHistory();
  const selfOrgUser = useSelfOrganizationUser();

  useEffect(() => {
    if (selfOrgUser && selfOrgUser.role !== "ADMIN") {
      history.push("/");
    }
  }, [history, selfOrgUser]);

  if (!selfOrgUser) {
    return <PageLoading />;
  }

  return (
    <StandardPageWrapper>
      <PageHeader titleContent="Privacy Docs" />

      <div className="flex-container flex--justify-center flex--align-center  content-wrapper">
        <div className="flex-container flex--justify-center flex--align-center mb-lg">
          <img src="/assets/images/stay_compliant/my_documents_hero.svg" alt="Documents" />
          <p className="color-primary-700 ml-xl text-weight-bold max-width-400">
            This is where you’ll find all your data privacy related documents.
          </p>
        </div>
        <FullPageButton
          content="Data Protection Assessments"
          href="/my-documents/data-protection-assessments"
        />
        <FullPageButton
          content="Record of Processing Activities (RoPA)"
          href="/my-documents/record-of-processing-activities"
          iconUrl="/assets/images/stay_compliant/icon_list.svg"
        />
        <FullPageButton
          content="HR Data Retention Policies"
          href="/my-documents/hr-data-retention-policies"
          iconUrl="/assets/images/stay_compliant/icon_person.svg"
        />
        <FullPageButton
          content="Privacy Policies"
          href="/my-documents/privacy-policies"
          iconUrl="/assets/images/stay_compliant/icon_list.svg"
        />
        <FullPageButton
          content="Audit Logs"
          href="/my-documents/audit-logs"
          iconUrl="/assets/images/stay_compliant/audit_logs.svg"
        />
        <FullPageButton
          content="My Files"
          href="/my-documents/my-files"
          iconUrl="/assets/images/stay_compliant/icon_list.svg"
        />
      </div>
    </StandardPageWrapper>
  );
};
